<!-- Consolidated templates to use computed isInvoiceComputed in setup -->

<template>
  <v-card v-if="donation && isInvoiceComputed" flat class="headline">
    <v-card-title :class="[reducedHeader ? 'reduced-header' : 'text-center headline mx-auto']">
      <v-icon v-if="!hideIcon" size="large" class="mr-3" color="primary">
        {{ sendIcon }}
      </v-icon>

      {{ t('success.invoice') }}
    </v-card-title>
    <v-card-subtitle>{{ getActionText }}</v-card-subtitle>
    <v-card-text>
      <div class="text-center">
        
        <!-- <v-btn
          role="presentation"
          aria-hidden="true"
          tabindex="-1"
          data-cy="success-view-fab-pulse-btn"
          style="pointer-events: none"
          class="ma-4 highlight-pulse"
          fab
          size="x-large"
          variant="outlined"
          color="success"
        >
      </v-btn> -->
          <v-icon color="white"> mdi-check </v-icon>
      </div>
    </v-card-text>
    <invoice-document-component v-if="!invoiceIsImage" :is-image="invoiceIsImage" />
  </v-card>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { RequestSession } from '@/interfaces/requestSession';
import { Donation } from '@/interfaces/donation/donation';
import InvoiceDocumentComponent from '@/components/invoice/InvoiceDocumentComponent.vue';
import { Type as PaymentType } from '@/interfaces/economy/paymentMethod';
import { isInvoice as isInvoiceFunc } from '@/classes/PaymentMethod';
import store from '@/store';
import { useLabel } from '@/composables/useLabel';

export default defineComponent({
  name: 'InvoiceView',
  components: { InvoiceDocumentComponent },
  props: {
    hideIcon: {
      type: Boolean,
      default: false,
    },
    reducedHeader: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['reset'],
  setup(props, { emit }) {
    const { t } = useLabel();

    const requestSession = computed((): RequestSession | null => store.state.requestSession);
    const donation = computed((): Donation | null => store.state.donation);
    const currentStep = computed(() => store.state.currentStep);

    const getActionText = computed(() => {
      const d = donation.value as Donation;
      return t('invoice.actionText', {
        invoiceDeliveryAction:
          d.paymentSpecification?.paymentMethod?.type === PaymentType.INVOICE_EMAIL
            ? t('invoice.invoiceSentToEmail', { email: d.donor.invoiceEmail })
            : d.paymentSpecification?.paymentMethod?.type === PaymentType.INVOICE_PRINT
              ? t('invoice.invoiceReadyForPrint')
              : t('invoice.invoiceWillBeMailed'),
      });
    });

    const invoiceIsImage = computed((): boolean => {
      const d = donation.value as Donation;
      return (
        d.paymentSpecification?.paymentMethod?.type === PaymentType.INVOICE_EMAIL ||
        d.paymentSpecification?.paymentMethod?.type === PaymentType.INVOICE_POST
      );
    });

    const sendIcon = computed(() => {
      const d = donation.value as Donation;
      return d.paymentSpecification?.paymentMethod?.icon;
    });

    const isInvoiceComputed = computed((): boolean => {
      const d = donation.value as Donation;
      return (
        d.paymentSpecification != null &&
        d.paymentSpecification.paymentMethod != null &&
        isInvoiceFunc(d.paymentSpecification.paymentMethod.type)
      );
    });

    const createdInvoice = computed(() => store.state.invoice);

    const reset = () => {
      emit('reset');
    };

    return {
      t,
      requestSession,
      donation,
      currentStep,
      getActionText,
      invoiceIsImage,
      sendIcon,
      isInvoiceComputed,
      createdInvoice,
      reset,
    };
  },
});
</script>
<style scoped>
.reduced-header {
  font-size: 20px !important;
  line-height: 24px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
